import { isPunctuatorToken } from "graphql/language/lexer";
import Head from "next/head";
import { useRouter } from "next/router";

import Footer from "../footer";
import BlogHeader from "./blogHeader";

type BlogLayoutProps = {
  pageTitle?: string;
  pageImageUrl?: string;
  pageDescription?: string;
  isArticle?: boolean;
  isProfile?: boolean;
  authorName?: string;
  children: JSX.Element | JSX.Element[];
};

const defaultTitle = "Blog";
const defaultDescription =
  "Blog Boehringer Click. Educación médica al alcance de un click.";

export default function BlogLayout({
  pageTitle,
  pageImageUrl,
  pageDescription,
  isArticle,
  children,
  authorName,
  isProfile,
}: BlogLayoutProps) {
  const { asPath } = useRouter();

  return (
    <>
      <Head>
        <meta
          content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0, shrink-to-fit=no"
          name="viewport"
        />
        <meta charSet="utf-8" />
        <link rel="icon" type="image/png" href="/img/favicon.png" />
        <meta httpEquiv="X-UA-Compatible" content="IE=edge,chrome=1" />

        <title>{`${pageTitle || defaultTitle} | Boehringer Click`}</title>
        <meta
          property="og:title"
          content={`${pageTitle || defaultTitle} | Boehringer Click`}
        />

        <meta property="og:url" content={process.env.NEXTAUTH_URL + asPath} />
        <link rel="canonical" href={process.env.NEXTAUTH_URL + asPath} />

        {pageImageUrl && <meta property="og:image" content={pageImageUrl} />}

        <meta
          property="og:description"
          content={pageDescription || defaultDescription}
        />
        <meta
          name="description"
          content={pageDescription || defaultDescription}
        />

        <meta property="og:site_name" content="Boehringer Click" />
        <meta property="og:locale" content="es_MX" />

        {isArticle ? (
          <meta property="og:type" content="article" />
        ) : isProfile ? (
          <meta property="og:type" content="profile" />
        ) : (
          <meta property="og:type" content="website" />
        )}

        {isArticle && authorName && (
          <meta property="article:author" content={authorName} />
        )}
      </Head>

      <BlogHeader />

      <main className="mt-16 bg-gray-100 font-boehringer_forward_head antialiased overflow-x-hidden">
        <div className="container">{children}</div>
      </main>

      <Footer />
    </>
  );
}
